var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFontsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "26px",
    viewBox: "0 0 44 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A7A039CF-BCC3-4A29-B441-D8E0CFC3C76A@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ready",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets/Downloads",
    transform: "translate(-755.000000, -534.000000)",
    fill: "#00689B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Other",
    transform: "translate(420.000000, 508.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fonts",
    transform: "translate(246.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Img",
    transform: "translate(72.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Aa",
    transform: "translate(17.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.69354839,25.5654596 L8.69354839,22.7409471 L5.99677419,22.7409471 L7.9483871,17.0557103 L16.8193548,17.0557103 L18.7709677,22.7409471 L16.1096774,22.7409471 L16.1096774,25.5654596 L24.8032258,25.5654596 L24.8032258,22.7409471 L22.3903226,22.7409471 L14.4064516,0 L10.3967742,0 L2.41290323,22.7409471 L0,22.7409471 L0,25.5654596 L8.69354839,25.5654596 Z M15.9322581,14.1587744 L8.83548387,14.1587744 L11.9225806,5.28690808 C12.2419355,4.2367688 12.3483871,3.33147632 12.3483871,3.33147632 L12.4548387,3.33147632 C12.4548387,3.33147632 12.5258065,4.2367688 12.8806452,5.28690808 L15.9322581,14.1587744 Z M32.3258065,26 C36.6903226,26 38.2516129,22.1253482 38.2516129,22.1253482 L38.3225806,22.1253482 C38.3225806,22.1253482 38.1806452,22.5961003 38.1806452,23.3203343 L38.1806452,23.5738162 C38.1806452,24.7688022 38.8193548,25.5654596 40.416129,25.5654596 L44,25.5654596 L44,22.8495822 L42.1903226,22.8495822 C41.6935484,22.8495822 41.4096774,22.5961003 41.4096774,22.0529248 L41.4096774,13.8690808 C41.4096774,9.23398329 38.9967742,6.80779944 34.4193548,6.80779944 C30.2322581,6.80779944 27.6064516,8.98050139 27.6064516,8.98050139 L28.9903226,11.4791086 C28.9903226,11.4791086 31.2967742,9.70473538 34.1354839,9.70473538 C36.3354839,9.70473538 37.9677419,10.718663 37.9677419,13.6155989 L37.9677419,14.3036212 L36.8322581,14.3036212 C33.8516129,14.3036212 26.3645161,14.7019499 26.3645161,20.45961 C26.3645161,24.2256267 29.3451613,26 32.3258065,26 Z M33.0709677,23.2841226 C31.0129032,23.2841226 29.8419355,21.7994429 29.8419355,20.1699164 C29.8419355,16.6573816 35.483871,16.5849582 37.116129,16.5849582 L38.0032258,16.5849582 L38.0032258,17.3454039 C38.0032258,20.097493 36.1225806,23.2841226 33.0709677,23.2841226 Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontsIcon);
export default __webpack_public_path__ + "d1a809511f4ca89a5dc689794a985d2d.svg";
export { ForwardRef as ReactComponent };